<script setup lang="ts">
import type { PinInputInputProps } from '.';

import { cn } from '@/utils';
import { PinInputInput, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<PinInputInputProps>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<PinInputInput
		v-bind="forwardedProps"
		:class="
			cn(
				'relative flex h-full w-1/6 items-center justify-center border border-white-dark-4 py-1 text-center text-sm text-primary transition-all focus:relative focus:z-10 focus:border-primary focus:outline-none focus:ring-0',
				props.class
			)
		"
	/>
</template>
